<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container-fluid">
      <input
        id="fileInput"
        ref="file"
        type="file"
        style="display: none"
        accept="image/*"
        @change="setPhoto"
      >


      <!-- sign up page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-sm-12 p-0">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img
                    src="@/assets/images/color_logo.png"
                    alt=""
                  >
                </div>
                <div
                  v-if="loaded"
                  class="card mt-4 p-4"
                >
                  <h4 class="text-center">
                    {{ $t('login.qeydiyyat') }}
                  </h4>
                  <h6 class="text-center">
                    {{ $t('register.zhmtOlmasaQeydiyyatnzTamalayn') }}
                  </h6>
                  <form
                    v-if="!requestTime"
                    class="theme-form"
                    @submit.prevent="sendForVerification"
                  >
                    <a
                      href="#"
                      class="bg-white d-block text-center p-2 rounded border"
                      @click.prevent="asanSession"
                    >
                      <img
                        src="@/assets/images/asan_login1.png"
                        style="height: 75px;"
                        class="img-fluid"
                        :alt="$t('login.asanLogin')"
                      >
                    </a>

                    <div class="lead text-center my-3">
                      {{ $t('register.vYa') }}
                    </div>

                    <div
                      v-if="idCardPhoto"
                      class="text-center"
                    >
                      <img
                        :src="mediaBase + '/' + idCardPhoto"
                        class="img-thumbnail cursor-pointer"
                        style="max-width: 100%; max-height: 200px;"
                        @click.prevent="selectPhoto"
                      >
                    </div>
                    <div v-else>
                      <div
                        class="alert alert-primary text-center cursor-pointer"
                        style="padding: 50px 20px;"
                        @click.prevent="selectPhoto"
                      >
                        <feather
                          type="upload"
                          size="40"
                        />
                        <br>
                        {{ $t('register.xsiyytiniziTsdiqEdnSndiYklyin') }}
                      </div>
                    </div>


                    <div
                      v-if="reason"
                      class="alert alert-danger mt-4"
                    >
                      {{ $t('register.vvlkiSndinQbulEdimmSbbi') }} <br>
                      <strong>{{ reason }}</strong>
                    </div>

                    <div class="alert alert-success mt-4">
                      {{ $t('register.sizinXsiyytVsiqnizinMlumatlarBizimMxfilikQaydalarm') }}
                    </div>
                    <div class="text-center">
                      <button
                        class="btn btn-primary"
                        type="submit"
                      >
                        {{ $t('register.tsdiqlmkNGndr') }}
                      </button>

                      <br>
                      <br>
                      <a
                        class="btn-link text-capitalize"
                        href="#"
                        @click.prevent="logout"
                      >{{ $t('passwordChange.x') }}</a>
                    </div>
                  </form>

                  <div v-else>
                    <div
                      class="alert alert-primary text-center my-4"
                      style="padding: 50px 20px;"
                    >
                      <feather
                        type="clock"
                        size="40"
                      />
                      <br>
                      {{ $t('register.hesabnzPortalAdminstrasiyasTrfindnYoxlanlr') }} <br>
                      {{ $t('register.zhmtOlmasaBirazSonraYenidnYoxlayn') }}
                    </div>

                    <div class="text-center">
                      <a
                        class="btn-link text-capitalize"
                        href="#"
                        @click.prevent="logout"
                      >{{ $t('passwordChange.x') }}</a>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-primary text-center">
                    {{ $t('register.mlumatlarYoxlanlr') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- sign up page ends-->
  </div>
  <!-- page-wrapper Ends-->
</template>

<script>
import {
  generateASANSession,
  requestVerification,
  upload,
  userMe
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";

export default {
  name: 'SignUp',

  data() {
    return {
      mediaBase: mediaBase,
      user: null,
      loaded: false,
      requestTime: null,
      idCardPhoto: null,
      reason: null,
      errors: {},
      uploadProgress: 0,
      timer: null
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      countryCode: state => state.auth.country
    }),
  },
  mounted() {
    this.getUserStatus();

    this.timer = setInterval(() => {
      this.getUserStatus();
    }, 5000);
  },
  methods: {
    getUserStatus() {
      userMe(this.token).then(({
                                 code,
                                 message,
                                 requestTime,
                                 reason
                               }) => {
        if (code === 200) {
          clearInterval(this.timer);
          this.$router.push({name: 'changePassword'});
        } else if (code === 201 || code === 424) {
          this.loaded = true;
          this.requestTime = requestTime;
          this.reason = reason;
        } else if (code === 409) {
          clearInterval(this.timer)
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("register.ayriFin"),
            icon: "warning"
          })
          localStorage.removeItem("token")

          this.$router.push({name: "login"})
        } else {
          clearInterval(this.timer);
          this.$swal({
            title: `Error ${code} !`,
            text: message,
            icon: 'error',
          })
        }

      });
    },

    asanSession() {
      generateASANSession().then(data => {
        if (data.code === 200) {
          window.location.href = 'https://asan.scc.az?transaction=' + data.key
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },


    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'idCard', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                this.idCardPhoto = response.data.path;

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: "Could not upload the file! " + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: "Photo upload is not supported on your browser",
          icon: 'error'
        })
      }
    },

    sendForVerification() {

      if (!this.idCardPhoto) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("register.xsiyytiniziTsdiqEdnSndiYklyin"),
          icon: 'warning'
        });
      } else {
        requestVerification(this.token, this.idCardPhoto).then(({code, message}) => {

          if (code === 200) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("register.successSend"),
              icon: 'success'
            });
            this.getUserStatus();
          } else {
            this.$swal({
              title: `Xəta ${code} !`,
              text: message,
              icon: 'error',
            })
          }

        });
      }

    },

    logout() {
      localStorage.removeItem('token');
      this.$router.push({name: 'login'});
    }
  }
}
</script>
